

import React from 'react';
import { useNavigate } from 'react-router-dom';

const Cart = ({ cartItems, onUpdateQuantity, onRemove }) => {
  const navigate = useNavigate();

  // Calculate total price
  const total = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

  // Proceed to Buy
  const handleCheckout = () => {
    navigate('/buynow', { state: { products: cartItems } });
  };

  return (
    <div className="container my-4 p-4 shadow-sm bg-white rounded">
      <h2 className="text-center mb-4">🛒 Your Shopping Cart</h2>

      {cartItems.length === 0 ? (
        <div className="alert alert-info text-center">Your cart is empty.</div>
      ) : (
        <>
          <ul className="list-group mb-3">
            {cartItems.map((item, index) => (
              <li
                key={index}
                className="list-group-item d-flex flex-column flex-md-row justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{ width: 60, height: 60, objectFit: 'cover', marginRight: 15 }}
                      className="rounded"
                    />
                  )}
                  <div>
                    <h6 className="mb-1">{item.name}</h6>
                    <p className="mb-0 text-muted">₹{item.price}</p>
                  </div>
                </div>

                <div className="d-flex align-items-center mt-2 mt-md-0">
                  <button
                    className="btn btn-sm btn-outline-secondary me-2"
                    onClick={() => onUpdateQuantity(index, item.quantity - 1)}
                    disabled={item.quantity === 1}
                  >
                    −
                  </button>
                  <span className="px-2">{item.quantity}</span>
                  <button
                    className="btn btn-sm btn-outline-secondary me-3"
                    onClick={() => onUpdateQuantity(index, item.quantity + 1)}
                  >
                    +
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => onRemove(index)}
                  >
                    🗑 Remove
                  </button>
                </div>
              </li>
            ))}
          </ul>

          <div className="d-flex justify-content-between align-items-center">
            <h4>Total</h4>
            <h4 className="text-primary">₹{total}</h4>
          </div>

          <div className="text-center mt-4">
            <button className="btn btn-success btn-lg px-4" onClick={handleCheckout}>
              🛍️ Proceed to Buy
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
